const { useRef } = require('react');

const internals = {};

internals.hasPreviousValue = (previousValue) => typeof previousValue !== 'undefined';

internals.shouldPreservePreviousValue = ({
    previousValue,
    value
}) => {

    if (typeof value === 'undefined' || value === null) {
        return internals.hasPreviousValue(previousValue);
    }

    if (Array.isArray(value)) {
        return value.length === 0
            && Array.isArray(previousValue)
            && previousValue.length > 0;
    }

    if (typeof value === 'object' && value && !Array.isArray(value)) {
        return !!previousValue
            && Object.keys(value).length === 0
            && Object.keys(previousValue).length > 0;
    }

    return false;
};

internals.buildStableProps = ({
    normalizeProps,
    props = {},
    stableRef,
    stickyPropNames = []
}) => {

    const previous = stableRef.current || {};
    const next = {
        ...props
    };

    stickyPropNames.forEach((propName) => {

        if (internals.shouldPreservePreviousValue({
            previousValue: previous[propName],
            value: props[propName]
        })) {
            next[propName] = previous[propName];
        }
    });

    const stableProps = typeof normalizeProps === 'function'
        ? normalizeProps(next)
        : next;

    stableRef.current = stableProps;
    return stableProps;
};

module.exports = function useStickyProps(props, options = {}) {

    const stableRef = useRef(props);

    return internals.buildStableProps({
        ...options,
        props,
        stableRef
    });
};

module.exports.internals = internals;
